var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "Template1"
  }, [_c('div', {
    staticClass: "card-header-tab"
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('button', {
      key: tab.key,
      class: ['tab-button ', {
        active: _vm.currentTab === tab.key
      }],
      attrs: {
        "disabled": (!_vm.callingFromClientContract && tab.key != 'First' && !_vm.contractidd)
      },
      on: {
        "click": function($event) {
          _vm.setTab(tab.key)
        }
      }
    }, [_vm._v("\n      " + _vm._s(tab.value) + "\n      "), (tab.value == 'Services') ? _c('span', {
      attrs: {
        "id": "first"
      }
    }, [_c('i', {
      staticClass: "fa fa-bars"
    })]) : _vm._e(), _vm._v(" "), (tab.value == 'Rates') ? _c('span', {
      attrs: {
        "id": "second"
      }
    }, [_c('i', {
      staticClass: "fa fa-percent"
    })]) : _vm._e(), _vm._v(" "), (tab.value == 'T&C') ? _c('span', {
      attrs: {
        "id": "third"
      }
    }, [_c('i', {
      staticClass: "fa fa-info"
    })]) : _vm._e(), _vm._v(" "), (tab.value == 'Annexures') ? _c('span', {
      attrs: {
        "id": "fourth"
      }
    }, [_c('i', {
      staticClass: "fa fa-certificate"
    })]) : _vm._e()])
  })), _vm._v(" "), (_vm.showTemplate) ? _c('div', [_c('keep-alive', [_c(_vm.currentTabComponent, {
    key: _vm.componentKey,
    ref: "Template1Ref",
    tag: "component",
    staticClass: "tab",
    attrs: {
      "contractidd": _vm.contractidd,
      "callingFromClientContract": _vm.callingFromClientContractObj,
      "selectedEdit": _vm.selectedEditRow
    },
    on: {
      "goBackToCreateContract": _vm.goBackToCreateContract,
      "checkForContractValidation": _vm.checkForContractValidation,
      "goBackToTemplate1": _vm.changeTab
    }
  })], 1)], 1) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04c0f8e0","hasScoped":true}!./src/modules/shared/components/Template1/Template1.component.html
// module id = 667
// module chunks = 3